import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { UserInfo, UserRoles } from '@/services/users/user-types';
import { format } from 'date-fns';
import CopyField from '@/common/forms/CopyField';
import routes from '@/routes/routes-enums';
import { formatCurrency } from '@/common/utils/formatCurrency';

export interface ColumnMeta {
  className?: string;
}

export const createColumns = (
  navigate: any,
  handleRoleChange: (user: UserInfo, role: string) => void,
): ColumnDef<UserInfo>[] => [
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => (
      <button onClick={() => navigate(`${routes.USER_EDIT}/${row.original.id}`)} className="btn btn-primary">
        <i className="ri-edit-2-line"></i>
      </button>
    ),
    enableSorting: false,
  },
  { accessorKey: 'alias', header: 'Alias', enableSorting: true },
  {
    accessorKey: 'firstName',
    header: 'First Name',
    enableSorting: true,
    size: 150,
  },
  { accessorKey: 'lastName', header: 'Last Name', enableSorting: true },
  {
    accessorKey: 'totalGeneratedRake',
    header: 'Total Rake',
    enableSorting: true,
    cell: (cell: any) => <div className="text-end">$ {formatCurrency(Number(cell.getValue()), 5)}</div>,
  },
  {
    accessorKey: 'createdAt',
    header: 'Registered on',
    cell: (cell: any) => format(cell.getValue(), 'yyyy-MM-dd'),
    enableSorting: true,
  },
  {
    accessorKey: 'lastLogin',
    header: 'Last Login',
    cell: (cell: any) => (cell.getValue() ? format(cell.getValue(), 'yyyy-MM-dd') : null),
    enableSorting: true,
  },
  {
    enableSorting: false,
    accessorKey: 'smartWalletAddress',
    header: 'Wallet Address',
    cell: ({ row }) => {
      return <CopyField name="Smart Wallet Address" lg={12} label={false} value={row.original?.smartWalletAddress} />;
    },
  },
  {
    accessorKey: 'email',
    header: 'Email',
    enableSorting: true,
    size: 200,
  },
  {
    enableSorting: true,
    id: 'userRole',
    accessorFn: (row) => {
      const isAgent = row.isAgent;
      const isAmbassador = row.isAmbassador;

      if (!isAgent && !isAmbassador) {
        return UserRoles.NO_ROLE;
      }

      if (isAgent) {
        return UserRoles.AGENT;
      }

      if (isAmbassador) {
        return UserRoles.AMBASSADOR;
      }
    },
    cell: (cell) => {
      return (
        <select
          name="role"
          id="roleSelect"
          value={cell.getValue() as string}
          onChange={(event) => {
            handleRoleChange(cell.row.original, event.target.value);
          }}
          className={'p-2'}
        >
          <option>{UserRoles.AGENT}</option>
          <option>{UserRoles.AMBASSADOR}</option>
          <option>{UserRoles.NO_ROLE}</option>
        </select>
      );
    },
    header: 'User Role',
  },
  {
    enableSorting: true,
    header: 'USDT Balance',
    accessorKey: 'usdtBalance',
    cell: (cell) => <div className="text-end">$ {formatCurrency(Number(cell.getValue()), 5)}</div>,
  },
  {
    header: 'PHNM Balance',
    enableSorting: true,
    accessorKey: 'phnmBalance',
    cell: (cell) => <div className="text-end">{formatCurrency(Number(cell.getValue()), 5)}</div>,
  },
  { accessorKey: 'referrerCode', header: 'Referrer Code', enableSorting: true },
  { accessorKey: 'referralCode', header: 'Referral Code', enableSorting: true },
];
